var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.776 2.333A5.706 5.706 0 0 1 12.386 7a5.706 5.706 0 0 1-11.22 0 5.706 5.706 0 0 1 5.61-4.667Zm0 8.297A4.67 4.67 0 0 0 11.327 7a4.67 4.67 0 0 0-9.102 0 4.67 4.67 0 0 0 4.551 3.63Zm0-1.297a2.333 2.333 0 1 1 0-4.666 2.333 2.333 0 0 1 0 4.666Zm0-1.037a1.296 1.296 0 1 0 0-2.592 1.296 1.296 0 0 0 0 2.592Z",
    fill: "#7F8286"
  })));
};
export default SvgEye;